import React from 'react';
import { ContactForm } from './ContactForm';
import { WaveBackground } from './WaveBackground';
export function FinalCTASection() {
  return <section id="contact-form" className="relative py-24 bg-[#0A1628] overflow-hidden" data-id="element-60">
      <WaveBackground data-id="element-61" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-62">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-16" data-id="element-63">
          <div className="flex-1 text-center lg:text-left" data-id="element-64">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-playfair leading-tight" data-id="element-65">
              Ready to Attract More Buyers and{' '}
              <span className="text-[#D4AF37]" data-id="element-66">Increase Boat Sales?</span>
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-67">
              Your competitors are investing in digital. The question is: are
              those buyers finding you… or finding them?
            </p>
          </div>

          <div className="flex-1 w-full max-w-md" data-id="element-68">
            <ContactForm title="Get Started Today" subtitle="Fill out the form below to schedule your free strategy call." data-id="element-69" />
          </div>
        </div>
      </div>
    </section>;
}